import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useMemo, useState } from "react";
import { getAxiosImportServer } from "../../shared/Services/importService";
import { IMPORT_TOURNAMENT } from "../../utils/api/ApiConstant";
import { DataTable, Filter, SubHeading, Switch } from "../../shared/Components";
import showToast from "../../utils/toastUtil";
import { postAxios } from "../../shared/Services/commonService";
import DateUtils from "../../utils/dateUtils";
import { createImportColumn } from "../../utils/importColumn";

const ImportStep2 = () => {
  const location = useLocation();
  const rowData = location.state;
  const navigate = useNavigate();
  const { source, id, sportName } = useParams();
  const [selectedItems, setSelectedItems] = useState({});
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["importTournamentData", source, id],
    queryFn: async () =>
      await getAxiosImportServer(`${IMPORT_TOURNAMENT}/${source}`, {
        eventType_id: id,
      }),
  });

  const handleSwitchToggle = (id) => {
    setSelectedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handleImport = async () => {
    const selectedIds = Object.keys(selectedItems)
      .filter((id) => selectedItems[id])
      .map((id) => String(id));

    if (selectedIds.length === 0) {
      showToast.info("Please select at least one item to import");
      return;
    }

    try {
      const response = await postAxios(`${IMPORT_TOURNAMENT}/${source}`, {
        competition_ids: selectedIds,
        eventType_id: id,
      });

      setSelectedItems({});
      refetch();
    } catch (error) {
      console.error("Import failed", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "Name",
        header: "Name",
        cell: ({ getValue, row }) => {
          return (
            <span
              onClick={() =>
                navigate(
                  `/config/import3/${source}/${id}/${row?.original?.Id}/${sportName}/${row?.original?.Name}`,
                  {
                    state: {
                      sport: rowData,
                      tournament: row?.original,
                      source: source,
                      sportId: id,
                    },
                  },
                )
              }
              className="cursor-pointer btn btn_default"
            >
              {getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "actionOn",
        header: "Action Date",
        cell: ({ getValue }) => DateUtils.fromUTC(getValue()),
      },
      createImportColumn({
        data,
        selectedItems,
        setSelectedItems,
        handleSwitchToggle,
      }),
    ],
    [data, selectedItems],
  );

  return (
    <>
      <SubHeading
        eyebrow="Configuration"
        breadcrumbs={[
          {
            label: "Import",
          },
          {
            label: `Sport (${sportName})`,
            path: "/configuration/import",
          },
          {
            label: "Tournaments",
          },
        ]}
        isAddBtnPage={false}
        isAddBtn={false}
        isBack={true}
        isImport={true}
        onClick={handleImport}
      />
      <Filter
        isEvent={true}
        isEventDisabled={true}
        buttonVisible={false}
        selectedSource={source}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data?.data}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default ImportStep2;
